import React, {useContext, useState} from "react";
import { GlobalUser } from "../types/common.types";
import SellerService from "../services/seller.service";
import { startOfToday } from 'date-fns'
import * as CommonTypes from '../types/common.types'
import { SellerContextType, Summary } from "../types/seller";

const SellerProvider = React.createContext<SellerContextType>(null as any)

export const SellerContext = ({children}: {children: React.ReactNode}) => {
    const getUser = () => {
        const user = localStorage.getItem('seller')
        if (user) {
            return JSON.parse(user)
        } else return null
    }
    // useStates
    const [user, setUser] = useState<GlobalUser>(getUser())
    const [tripInfo, setTripInfo] = useState<CommonTypes.FullReservation | undefined>()
    const [isPassengersModalOpen, setIsPassengersModalOpen] = useState<boolean>(false)
    const [isCreatePassengerModalOpen, setIsCreatePassengerModalOpen] = useState<boolean>(false)
    const [createReservationTourId, setCreateReservationTourId] = useState<string>('')
    const [newPassenger, setNewPassenger] = useState<Partial<CommonTypes.Passenger> | undefined>()
    const [newReservationData, setNewReservationData] = useState<Partial<CommonTypes.Reservation> | undefined>()
    const [isTicketPaymentModalOpen, setIsTicketPaymentModalOpen] = useState<boolean>(false)
    const [sellerInfo, setSellerInfo] = useState<CommonTypes.HealthSeller>({} as CommonTypes.HealthSeller)
    const [sellerTab, setSellerTab] = useState('profile')
    const [editReservationId, setEditReservationId] = useState<string>('')
    const [isCreateGroupModalOpen, setIsCreateGroupModalOpen] = useState<boolean>(false)
    const [newGroup, setNewGroup] = useState<Partial<CommonTypes.Passenger>[]>([])
    const [newGroupReservationData, setNewGroupReservationData] = useState<Partial<CommonTypes.Reservation> | undefined>()
    const [isTicketPaymentGroupModalOpen, setIsTicketPaymentGroupModalOpen] = useState<boolean>(false)
    const [isConfirmBoucherModalOpen, setIsConfirmBoucherModalOpen] = useState<boolean>(false)
    const [newGroupReservations, setNewGroupReservations] = useState<CommonTypes.Reservation[]>([])
    const [summary, setSummary] = useState<Summary[]>([])
    const [isSummaryModalOpen, setIsSummaryModalOpen] = useState<boolean>(false)
    const [confirmDeleteReservationId, setConfirmDeleteReservationId] = useState<string>('')
    const [viewPaymentsData, setViewPaymentsData] = useState<CommonTypes.ReservationPayment[]>()
    const [reservationData, setReservationData] = useState<CommonTypes.ReservationPaymentList | undefined>()
    const [createPaymentReservationId, setCreatePaymentReservationId] = useState<string>('')
    const [createPaymentGroupId, setCreatePaymentGroupId] = useState<string>('')
    const [isCreatePaymentModalOpen, setIsCreatePaymentModalOpen] = useState<boolean>(false)

    const [currentDay, setCurrentDay] = useState<Date>(startOfToday())

    user?.token && SellerService.setToken(user.token)

    const values = {
        user, setUser,
        currentDay, setCurrentDay,
        tripInfo, setTripInfo,
        isPassengersModalOpen, setIsPassengersModalOpen,
        isCreatePassengerModalOpen, setIsCreatePassengerModalOpen,
        createReservationTourId, setCreateReservationTourId,
        newPassenger, setNewPassenger,
        newReservationData, setNewReservationData,
        isTicketPaymentModalOpen, setIsTicketPaymentModalOpen,
        sellerInfo, setSellerInfo,
        sellerTab, setSellerTab,
        editReservationId, setEditReservationId,
        isCreateGroupModalOpen, setIsCreateGroupModalOpen,
        newGroup, setNewGroup,  
        newGroupReservationData, setNewGroupReservationData,    
        isTicketPaymentGroupModalOpen, setIsTicketPaymentGroupModalOpen,
        isConfirmBoucherModalOpen, setIsConfirmBoucherModalOpen,
        newGroupReservations, setNewGroupReservations,
        summary, setSummary,
        isSummaryModalOpen, setIsSummaryModalOpen,
        confirmDeleteReservationId, setConfirmDeleteReservationId,
        viewPaymentsData, setViewPaymentsData,
        reservationData, setReservationData,
        createPaymentReservationId, setCreatePaymentReservationId,
        isCreatePaymentModalOpen, setIsCreatePaymentModalOpen,
        createPaymentGroupId, setCreatePaymentGroupId,
    }
    return <SellerProvider.Provider value={values}>{children}</SellerProvider.Provider>;
}

export const useSeller = () => {
    return useContext(SellerProvider)
}